



































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { SuketBebasNapzaInterface } from "@/types/suket_bebas_napza";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketBebasNapza from "@/services/SuketBebasNapza";
import StoreSuketBebasNapza from "@/store/modules/SuketBebasNapza";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardInputSKNapza extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSkNapza!: SuketBebasNapzaInterface;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  register_id = this.dataSkNapza?.register_id || this.register;
  pasien_rm = this.dataSkNapza?.pasien_rm || this.statePasien.rm;
  nama = this.dataSkNapza?.nama || this.statePasien.nama;
  umur =
    this.dataSkNapza?.umur ||
    getAge(formatDMYDate(this.statePasien.tgl_lahir))
      .toString()
      .concat(" Th");
  pekerjaan = this.dataSkNapza?.pekerjaan || this.statePasien.pekerjaan;
  alamat = this.dataSkNapza?.alamat || this.statePasien.alamat;
  keterangan = this.dataSkNapza?.keterangan || "0";
  tujuan = this.dataSkNapza?.tujuan || "";
  pemeriksaan_urin = this.dataSkNapza?.pemeriksaan_urin || [];
  unit_id = this.dataSkNapza?.unit_id || this.user.unit_id;
  dokter_id = this.dataSkNapza?.dokter_id || this.user.id;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkNapza = false;
  saving = false;
  pemeriksaanUrinOptions = [
    {
      id: 1,
      name: "Morphin/MOP",
      value: "negatif"
    },
    {
      id: 2,
      name: "Canabinold/THC",
      value: "negatif"
    },
    {
      id: 3,
      name: "Methamphetamine/MET",
      value: "negatif"
    },
    {
      id: 4,
      name: "Amphetamine/AMP",
      value: "negatif"
    },
    {
      id: 5,
      name: "Benzodiazepine/BZO",
      value: "negatif"
    },
    {
      id: 6,
      name: "Cocaine",
      value: "negatif"
    }
  ];

  pemeriksaanUrinValueItems = [
    {
      text: "Negatif",
      value: "negatif"
    },
    {
      text: "Positif",
      value: "positif"
    }
  ];

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register,
      unit_id: this.unit_id,
      dokter_id: this.dokter_id,
      pasien_rm: this.pasien_rm,
      nama: this.nama,
      umur: this.umur,
      pekerjaan: this.pekerjaan,
      alamat: this.alamat,
      keterangan: this.keterangan,
      tujuan: this.tujuan,
      pemeriksaan_urin: this.pemeriksaan_urin
    };
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSkNapza
        ? SuketBebasNapza.update(this.dataSkNapza.id, this.input)
        : SuketBebasNapza.create(this.input);

      action
        .then(() => {
          this.$emit("showSignatureModal");

          appModule.NoticeDelay("Berhasil Simpan Surat Keterangan Mata");

          this.close();
          StoreSuketBebasNapza.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
